import { loadFirebaseAuth } from "./firebase";
import { signOut } from "firebase/auth";
import { catch_error } from "./functions";
jQuery(document).ready(function ($) {
  $("form.form__logout").on("submit", function (e) {
    e.preventDefault();

    $("#logout_submit").addClass("logout--button--loading");
    $("#logout_submit").prop("disabled", true);
    const firebaseAuth = loadFirebaseAuth();
    signOut(firebaseAuth)
      .then(() => {
        let name = "";
        if (localStorage.getItem("user_info")) {
          if (JSON.parse(localStorage.getItem("user_info"))) {
            if (
              JSON.parse(localStorage.getItem("user_info")).firstName !== "" &&
              JSON.parse(localStorage.getItem("user_info")).lastName !== ""
            ) {
              name = `${
                JSON.parse(localStorage.getItem("user_info")).firstName
              } ${JSON.parse(localStorage.getItem("user_info")).lastName}`;
            } else {
              if (JSON.parse(localStorage.getItem("user_info")).username) {
                if (
                  JSON.parse(localStorage.getItem("user_info")).username !== ""
                ) {
                  name = JSON.parse(localStorage.getItem("user_info")).username;
                }
              } else {
                name = JSON.parse(localStorage.getItem("user_info")).email;
              }
            }
          }
        }

        $("body").append(`
    <script type="text/javascript">
  dataLayer.push( {
	event: "logout_clicked",
	category: "user_sign_in",
  label: '${name}'
  } );
  </script>
    `);
      })
      .then(() => {
        localStorage.removeItem("login_result");
        localStorage.removeItem("user");
        localStorage.removeItem("user_info");
        window.location.href = "/";
        $("#logout_submit").removeClass("logout--button--loading");
        $("#logout_submit").prop("disabled", false);
      })
      .catch((error) => {
        catch_error(error);
        $("#logout_submit").removeClass("logout--button--loading");
        $("#logout_submit").prop("disabled", false);
      });
  });
});
